export class Paginacao {

  private _page: number;
  private _itens: number;
  private _id: string;

  set id(id: string) {
    this._id = id;
  }

  get id(): string {
    return this._id;
  }

  set page(page: number) {
    this._page = page;
  }

  set itens(itens: number) {
    this._itens = itens;
  }

  get page(): number {
    return this._page;
  }

  get itens(): number {
    return this._itens;
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/paginacao.ts